import React from 'react';
import { Box, Typography, Container, Paper, List, ListItem } from '@mui/material';
import { Helmet } from 'react-helmet';

const Terms = () => {
  return (
    <Box>
      <Helmet>
        <title>Terms - HawkClient</title>
        <meta
          name="description"
          content="Read the license terms and usage conditions for HawkClient, the free API testing tool."
        />
      </Helmet>

      <Container maxWidth="sm" sx={{ mt: 6 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h4" gutterBottom>
            HawkClient License Agreement
          </Typography>

          <Typography variant="body1" paragraph>
            Copyright © 2024–2026 Prashant Rathi
          </Typography>

          <Typography variant="body1" paragraph>
            HawkClient is licensed for use free of charge. You are permitted to install and use this software
            for personal or commercial use.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>Ownership:</strong><br />
            This Agreement does not convey to you any rights of ownership in the software. All rights, title, benefit,
            and interest in and to HawkClient — including but not limited to the software, documentation, branding,
            and any modifications or enhancements — are and shall remain the exclusive property of Prashant Rathi.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>You may not:</strong>
          </Typography>

          <List sx={{ pl: 3 }}>
            <ListItem sx={{ display: 'list-item' }}>
              1. Modify, reverse engineer, decompile, or disassemble this software.
            </ListItem>
            <ListItem sx={{ display: 'list-item' }}>
              2. Redistribute or resell the software without written permission.
            </ListItem>
            <ListItem sx={{ display: 'list-item' }}>
              3. Access or extract the source code.
            </ListItem>
          </List>

          <Typography variant="body1" paragraph>
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
            INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
            IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
            WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </Typography>

          <Typography variant='body1' paragraph>
            <strong>Changes to the License</strong><br/>
            The author reserves the right to modify or update this license at any time. Continued use of the software after such changes constitutes acceptance of the new terms.
          </Typography>

          <Typography variant="body1" paragraph>
            By using this software, you agree to the terms above.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Terms;
